<script>
    import { onMount } from 'svelte';

    export let zoom;
    export let coordinates;
    export let token;
    export let pin;

    let isDarkMode = false;
    let mapStyle = 'light-v11';
    let mapContainer;
    let map;

    const setMapStyle = () => {
        mapStyle = isDarkMode ? 'dark-v11' : 'light-v11';
        if (map) {
            map.setStyle(`mapbox://styles/mapbox/${mapStyle}`);
        }
    };

    onMount(() => {
        if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
            isDarkMode = true;
            setMapStyle();
        }

        window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', (event) => {
            isDarkMode = event.matches;
            setMapStyle();
        });

        map = new mapboxgl.Map({
            container: mapContainer,
            style: `mapbox://styles/mapbox/${mapStyle}`,
            accessToken: token,
            center: coordinates,
            zoom: zoom,
            cooperativeGestures: true,
        });

        if (pin) {
            const el = document.querySelector('.marker');
            new mapboxgl.Marker(el).setLngLat(coordinates).addTo(map);
        }
    });
</script>

<div class="map-wrapper">
    <div class="map" bind:this={mapContainer} />
    {#if pin}
        <div class="marker"></div>
    {/if}
</div>

<style>
    .map {
        display: block;
        width: 100%;
        aspect-ratio: 4 / 3;

        /* aspect-ratio: 16 / 9; */
    }

    .marker {
        width: 1.25em;
        height: 1.25em;
        background-color: #06aee0;
    }
</style>
